/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReassignFormRequest
 */
export interface ReassignFormRequest {
    /**
     * 
     */
    assignedOperatorId?: string;
    /**
     * 
     */
    dueAt?: string;
}

/**
 * Check if a given object implements the ReassignFormRequest interface.
 */
export function instanceOfReassignFormRequest(value: object): value is ReassignFormRequest {
    return true;
}

export function ReassignFormRequestFromJSON(json: any): ReassignFormRequest {
    return ReassignFormRequestFromJSONTyped(json, false);
}

export function ReassignFormRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReassignFormRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'assignedOperatorId': json['assignedOperatorId'] == null ? undefined : json['assignedOperatorId'],
        'dueAt': json['dueAt'] == null ? undefined : json['dueAt'],
    };
}

export function ReassignFormRequestToJSON(json: any): ReassignFormRequest {
    return ReassignFormRequestToJSONTyped(json, false);
}

export function ReassignFormRequestToJSONTyped(value?: ReassignFormRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignedOperatorId': value['assignedOperatorId'],
        'dueAt': value['dueAt'],
    };
}

